// ** React Imports
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const ActivitiesList = lazy(() => import('../../views/roads/activities/list'));
const ActivitiesListResponse = lazy(() =>
  import('../../views/roads/activities/response.jsx')
);
const NewActivity = lazy(() => import('../../views/roads/activities/new'));
const EditActivity = lazy(() => import('../../views/roads/activities/edit'));

const EpisodeList = lazy(() => import('../../views/roads/episodes/list'));
const NewEpisode = lazy(() => import('../../views/roads/episodes/new'));
const EditEpisode = lazy(() => import('../../views/roads/episodes/edit'));
const EpisodeDetails = lazy(() => import('../../views/roads/episodes/edit'));

const RoadList = lazy(() => import('../../views/roads/roads/list/index.jsx'));
const RoadDetails = lazy(() => import('../../views/roads/roads/details'));
const NewRoad = lazy(() => import('../../views/roads/roads/new'));
const EditRoad = lazy(() => import('../../views/roads/roads/edit'));

const RoadsRoutes = [
  {
    element: <RoadList />,
    path: '/roads/list',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <NewRoad />,
    path: '/roads/new',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    path: '/roads/edit',
    element: <Navigate to="/roads/list" />,
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <EditRoad />,
    path: '/roads/edit/:id',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    path: '/roads/details',
    element: <Navigate to="/roads/list" />,
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <RoadDetails />,
    path: '/roads/details/:id',
    meta: {
      permission: 'ROADS'
    }
  }
];

const ActivityRoutes = [
  {
    element: <ActivitiesList />,
    path: '/roads/activities/list',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <NewActivity />,
    path: '/roads/activities/new',
    meta: {
      className: 'todo-application',
      permission: 'ROADS'
    }
  },
  {
    path: '/roads/activities/edit',
    element: <Navigate to="/roads/activities/list" />,
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <EditActivity />,
    path: '/roads/activities/edit/:id',
    meta: {
      className: 'todo-application',
      permission: 'ROADS'
    }
  },
  {
    element: <ActivitiesListResponse />,
    path: '/roads/activities/response/:id',
    meta: {
      className: 'todo-application',
      permission: 'ROADS'
    }
  }
];

const EpisodeRoutes = [
  {
    element: <EpisodeList />,
    path: '/roads/episodes/list',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <NewEpisode />,
    path: '/roads/episodes/new',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    path: '/roads/episodes/edit',
    element: <Navigate to="/roads/episodes/list" />,
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <EditEpisode />,
    path: '/roads/episodes/edit/:id',
    meta: {
      permission: 'ROADS'
    }
  },
  {
    element: <EpisodeDetails />,
    path: '/roads/episodes/details/:id',
    meta: {
      permission: 'ROADS'
    }
  }
];

export default [...RoadsRoutes, ...ActivityRoutes, ...EpisodeRoutes];
